
export default {
    name: 'atcd-historique-adulte-personnel',
    components: {},
    props: ["consultation", "activeRole"],
    data() {
        return {
            is_loading: true,
            is_physio: true,
            histo_is_empty: false,
        }
    },
    computed: {
        antecedent_adulte_personnel_historique() {
            return this.$store.getters["antecedent_adulte_personnel_historique"];
        },
    },
    mounted() {
        this.listeChampATCDAdultePersonnel()
    },
    methods: {
        async listeChampATCDAdultePersonnel() {
            this.is_loading = true
            let filter_data = {
                consultation_id: this.consultation.id,
                data_type: 'antecedent_adulte_personnel',
                est_en_cours: false
            }

            this.$store.dispatch('getConsultationAntecedent', filter_data).then(() => {
                if (this.antecedent_adulte_personnel_historique.length == 0) {
                    this.histo_is_empty = true
                } else {
                    this.histo_is_empty = false
                }
                this.is_loading = false
            })
        },

        toggleSection() {
            this.is_physio = (this.is_physio)?false:true
        },
    }
}


